import { createContext } from 'react';
import type { CommentStore } from './FloatingCommentSidebar/store';

export const CommentStoreContext = createContext<CommentStore | null>(null);
